import { WritableComputedRef, nextTick } from 'vue'
import { I18n, createI18n } from 'vue-i18n'

let i18n: I18n
const loadedLanguages: Array<string> = []

export function setupI18n() {
  i18n = createI18n({
    legacy: false,
    globalInjection: true
  })
  return i18n
}

export function setI18nLanguage(locale: string) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    ;(i18n.global.locale as WritableComputedRef<string>).value = locale
  }
  document.querySelector('html')?.setAttribute('lang', locale)
}

export async function loadLocaleMessages(locale: string) {
  if (!loadedLanguages.includes(locale)) {
    const messages = await import(/* webpackChunkName: "locale-[request]" */ `./locales/${locale}.json`)
    i18n.global.setLocaleMessage(locale, messages.default)
    loadedLanguages.push(locale)
  }
  return nextTick()
}
